import { useTranslation } from 'react-i18next';
import { NotificationContentRead } from './notificationContent/NotificationContentRead';
import { NotificationContentWrite } from './notificationContent/NotificationContentWrite';

const NotificationSubject = ({ textContent, onChange, canEdit }) => {
  const { t: translator } = useTranslation();

  if (canEdit) {
    return (
      <NotificationContentWrite
        textContent={textContent}
        onChange={onChange}
        header={translator('notificationContent.subject')}
        ariaLabel={translator('ariaLabel.notificationSubjectWrite')}
      />
    );
  }
  return (
    <NotificationContentRead
      textContent={textContent}
      header={translator('notificationContent.subject')}
      ariaLabel={translator('ariaLabel.notificationSubjectRead')}
    />
  );
};
export { NotificationSubject };
